import "./index.scss";
import { initWishlist, wishlistOn, bindWishlistBtn } from "@olmokit/core/wishlist";
import { globalData, globalConf } from "@olmokit/core/data";
// import { $ } from "@olmokit/dom";

/**
 * Component: ProductCard
 */
export function ProductCard() {
  console.log("ProductCard mounted.");

  const user = globalData.user;

  if(user.length > 0){
    initWishlist();
    bindWishlistBtn();
  }

  wishlistOn("add:ok", (data) => {
    // dlAddWishlist();
  });

  /**
   * Questo non va
   */
  wishlistOn("remove:ok", (data) => {
    // dlAddWishlist();
  });  
}
